import { Tenant } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useUpdateTenantQuery = (tenantId: string) => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/tenants/${tenantId}`
	return useLazyQuery<Partial<Tenant>, void>(url, "PATCH")
}
